import React from "react";
import { FiEye } from "react-icons/fi";
import ApprovalStatusBadge from "./ApprovalStatusBadge";

const ApprovalTableMobile = ({ quotations, navigate }) => {
  return (
    <div className="space-y-4 md:hidden transition-colors duration-300">
      {quotations.length > 0 ? (
        quotations.map((qt) => (
          <div
            key={qt._id}
            className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 
                       p-4 rounded-lg shadow-sm transition-colors duration-300"
          >
            {/* ข้อมูลรายละเอียด */}
            <div className="mb-2 space-y-1 text-sm text-gray-800 dark:text-gray-200">
              <InfoRow label="Run Number" value={qt.runNumber || "-"} />
              <InfoRow label="Title" value={qt.title || "-"} />
              <InfoRow label="Client" value={qt.client || "N/A"} />
              <InfoRow
                label="Document Date"
                value={
                  qt.documentDate
                    ? new Date(qt.documentDate).toLocaleDateString("en-GB")
                    : "-"
                }
              />
              <InfoRow
                label="Net Amount"
                value={
                  qt.netAmount
                    ? qt.netAmount.toLocaleString("th-TH", {
                        style: "currency",
                        currency: "THB",
                      })
                    : "-"
                }
              />
              <p>
                <span className="font-semibold text-gray-900 dark:text-blue-400">
                  Status:
                </span>{" "}
                <ApprovalStatusBadge status={qt.approvalStatus} />
              </p>
              <InfoRow
                label="Created By"
                value={qt.createdByUser ? qt.createdByUser.split("@")[0] : "-"}
              />
            </div>

            {/* ปุ่ม View */}
            <div className="flex gap-2 mt-3">
              <button
                onClick={() => navigate(`/quotation-details/${qt._id}`)}
                className="p-2 rounded-md bg-blue-100 text-blue-700 hover:bg-blue-200 
                           dark:bg-blue-900/40 dark:text-blue-300 dark:hover:bg-blue-800/60
                           transition-colors duration-200"
                title="View"
              >
                <FiEye size={16} />
              </button>
            </div>
          </div>
        ))
      ) : (
        <p className="text-center text-gray-600 dark:text-gray-400 transition-colors duration-300">
          No approval requests found.
        </p>
      )}
    </div>
  );
};

// ✅ แยก Component ย่อยเพื่อความสะอาด
const InfoRow = ({ label, value }) => (
  <p>
    <span className="font-semibold text-gray-900 dark:text-blue-400">
      {label}:
    </span>{" "}
    {value}
  </p>
);

export default ApprovalTableMobile;
